import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import { MessageCircle, Users, Settings as SettingsIcon, Ghost } from "lucide-react";
import ChatsTab from "@/components/ChatsTab";
import FriendsTab from "@/components/FriendsTab";
import SettingsTab from "@/components/SettingsTab";

const TABS = [
  { id: "chats", label: "Discussions", icon: MessageCircle, testid: "nav-chats-tab" },
  { id: "friends", label: "Amis", icon: Users, testid: "nav-friends-tab" },
  { id: "settings", label: "Réglages", icon: SettingsIcon, testid: "nav-settings-tab" },
];

export default function Home() {
  const { user } = useAuth();
  const [tab, setTab] = useState("chats");

  return (
    <div className="min-h-screen bg-[#050505] pb-28">
      <header
        className="glass sticky top-0 z-50 border-b border-white/5 py-4 px-6 flex justify-between items-center"
        style={{ paddingTop: "calc(1rem + env(safe-area-inset-top))" }}
      >
        <div className="flex items-center gap-3">
          <div className="h-9 w-9 rounded-xl border border-white/10 bg-[#121212] flex items-center justify-center">
            <Ghost className="h-5 w-5 text-[#A3B8CC]" strokeWidth={1.5} />
          </div>
          <h1 className="font-display text-2xl font-semibold tracking-tight">Wado</h1>
        </div>
        {user?.ghost_mode && (
          <div
            data-testid="ghost-mode-header-indicator"
            className="flex items-center gap-2 rounded-full border border-[#A3B8CC]/30 px-3 py-1.5 ghost-glow"
          >
            <Ghost className="h-4 w-4 text-[#A3B8CC]" strokeWidth={1.5} />
            <span className="text-xs tracking-[0.15em] uppercase font-bold text-[#A3B8CC]">Fantôme</span>
          </div>
        )}
      </header>

      <main className="max-w-2xl mx-auto px-6 sm:px-8 pt-8">
        <AnimatePresence mode="wait">
          <motion.div
            key={tab}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.3 }}
          >
            {tab === "chats" && <ChatsTab />}
            {tab === "friends" && <FriendsTab />}
            {tab === "settings" && <SettingsTab />}
          </motion.div>
        </AnimatePresence>
      </main>

      <nav
        className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 glass border border-white/10 rounded-full px-2 py-2 flex items-center gap-1 shadow-[0_8px_32px_rgba(0,0,0,0.5)]"
        style={{ bottom: "calc(1.5rem + env(safe-area-inset-bottom))" }}
      >
        {TABS.map((t) => {
          const Icon = t.icon;
          const active = tab === t.id;
          return (
            <button
              key={t.id}
              data-testid={t.testid}
              onClick={() => setTab(t.id)}
              className={`flex items-center gap-2 rounded-full px-5 py-2.5 transition-colors duration-300 ${
                active ? "bg-white text-black" : "text-[#8A8A8A] hover:text-white"
              }`}
            >
              <Icon className="h-4 w-4" strokeWidth={2} />
              <span className="text-sm font-medium hidden sm:inline">{t.label}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
}
